import { Component } from '@angular/core';
import { OptService } from 'src/app/services/opt.service';

@Component({
  selector: 'upsc-optout',
  templateUrl: './optout.component.html',
  styleUrls: ['./optout.component.scss']
})
export class OptoutComponent {


  constructor(private optService: OptService) { }
  user: any = {
    cpi: 1,
    LastName: '',
    StreetAddress1: '',
    StreetAddress2: '',
    StreetAddress3: '',
    FirstName: '',
    City: '',
    Country: '',
    State: '',
    Zip: '',
    EmailAddress: '',
    DoNotSell: '',
    DoNotShare: '',
    Keep_Remove: ''
  };

  onSubmit() {
    if (this.user.cpi == 1) {
      let FirstName = this.user.FirstName;
      let LastName = this.user.LastName;
      let StreetAddress1 = this.user.AddressLine1;
      let City = this.user.City;
      let State = this.user.State;
      let Country = this.user.Country;
      let DoNotSell = this.user.DoNotSell;
      let DoNotShare = this.user.DoNotShare;
      let Zipcode = this.user.Zipcode;
      let EmailAddress = this.user.Email;
      let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(EmailAddress) && FirstName && LastName && Country && Zipcode && StreetAddress1 && City && State) {
        console.log(this.user);

        this.user.DoNotSell = DoNotSell ? "1" : "";
        this.user.DoNotShare = DoNotShare ? "1" : "";
        this.optService.submitLead(this.user).subscribe(
          response => {
             console.log('Lead submitted:', response);
            if (response.data.responseMessage) {
              alert(response.data.responseMessage);
              this.user = {
                cpi: 1,
                LastName: '',
                StreetAddress1: '',
                StreetAddress2: '',
                StreetAddress3: '',
                FirstName: '',
                City: '',
                Country: '',
                State: '',
                Zip: '',
                EmailAddress: '',
                DoNotSell: '',
                DoNotShare: '',
                Keep_Remove: ''
              };
            }
            else {
              alert("Something went wrong. Please try again");
            }
            

          },
          error => {
            // console.error('Error:', error);
            alert('Failed to submit lead.');
          }
        );
      }
      else if (!emailRegex.test(EmailAddress) && FirstName && LastName && Country && Zipcode && StreetAddress1 && City && State) {
        alert('Please fill valid email ID');
      }
      else {
        alert('Please fill in all fields!');
        return false;
      }

    }
  }
}
